export const screenMaxWidths = {
    superWideScreen: 6000,
    wideScreen: 4500,
    desktop: 1800,
    tablet: 1350,
    mobile: 740
}